<template>
  <div class="dv-scroll"
       style="width:100%;height:100%">
    <dv-scroll-board :config="config"
                     style="width:100%;height:90%" />
  </div>
</template>

<script>
export default {
  watch: {
    shipmentsLsit(val) {
      // this.$set(this.config, 'data', this.shipmentsLsit)
      this.config = { ...this.config, data: this.shipmentsLsit }
      console.log(this.config, 'this.config', val)
    },
  },
  props: {
    shipmentsLsit: {
      // 月份
      type: Object,
      default: () => [],
    },
    monthlyWeight: {
      // 净重
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.config
  },
  data: function () {
    return {
      config: {
        // deptIdName
        // vehicleNo 车号
        // varNoName 物料
        // money 交易金额
        // tareWeight 皮重
        // grossTime  重车时间
        columnWidth: [100, 100, 100, 100, 100, 200],
        header: ['单位', '车号', '物料', '交易金额', '皮重', '重车时间'],
        data: [],
      },
    }
  },
}
</script>

<style scoped>
.dv-scroll {
  box-sizing: border-box;
  text-align: center;
  padding: 0 30px;
  padding-top: 80px;
}
</style>
